import { TEAM_AVAILABILITY_REQUEST, TEAM_AVAILABILITY_SUCCESS, TEAM_AVAILABILITY_FAILURE } from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { queryStringBuilder } from '../../../utils/helpers';

export function getTeamAvailability(data) {
  return {
    types: [TEAM_AVAILABILITY_REQUEST, TEAM_AVAILABILITY_SUCCESS, TEAM_AVAILABILITY_FAILURE],
    shouldCallAPI: () => true,
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: `v1/query/GetStaffAvailability${queryStringBuilder(data)}`,
    }),
  };
}
